/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_Sign_InInputs */

const th_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อทดลองประชุมสองคน`)
};

const en_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to try a two-person meeting.`)
};

const ja_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインして2人でミーティングを試せます。`)
};

const zh_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后可测试双人会议。`)
};

const es_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para probar una reunión de dos personas.`)
};

const pt_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para testar uma reunião de duas pessoas.`)
};

const id_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk menguji pertemuan dua orang.`)
};

const fr_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour tester une réunion à deux.`)
};

const tl_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in para subukan ang mitingang dalawahan.`)
};

const vi_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để thử cuộc họp hai người.`)
};

const ko_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2인 회의를 테스트하려면 로그인하세요.`)
};

const de_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um ein Meeting zu zweit zu testen.`)
};

const ru_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы проверить встречу на двоих.`)
};

const tr_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İki kişilik toplantıyı denemek için giriş yapın.`)
};

const it_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per provare una riunione a due.`)
};

const pl_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby przetestować spotkanie we dwoje.`)
};

const uk_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть, щоб перевірити зустріч на двох.`)
};

const hi_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दो लोगों की बैठक जाँचने के लिए साइन इन करें।`)
};

const ar_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لتجربة اجتماع بين شخصين.`)
};

const ms_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk menguji mesyuarat dua orang.`)
};

const bn_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দুজনের সভা পরীক্ষা করতে সাইন ইন করুন।`)
};

const zh_tw2_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可測試雙人會議。`)
};

const zh_hk2_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可測試雙人會議。`)
};

const ur_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دو افراد کی ملاقات آزمانے کے لیے سائن اِن کریں۔`)
};

const fa_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای آزمودن جلسهٔ دونفره وارد شوید.`)
};

const sw_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kujaribu mkutano wa watu wawili.`)
};

const nl_meeting_test_sign_in = /** @type {(inputs: Meeting_Test_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om een gesprek met z'n tweeën te testen.`)
};

/**
* | output |
* | --- |
* | "Sign in to try a two-person meeting." |
*
* @param {Meeting_Test_Sign_InInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_sign_in = /** @type {((inputs?: Meeting_Test_Sign_InInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_Sign_InInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_sign_in(inputs)
	if (locale === "ja") return ja_meeting_test_sign_in(inputs)
	if (locale === "zh") return zh_meeting_test_sign_in(inputs)
	if (locale === "es") return es_meeting_test_sign_in(inputs)
	if (locale === "pt") return pt_meeting_test_sign_in(inputs)
	if (locale === "id") return id_meeting_test_sign_in(inputs)
	if (locale === "fr") return fr_meeting_test_sign_in(inputs)
	if (locale === "tl") return tl_meeting_test_sign_in(inputs)
	if (locale === "vi") return vi_meeting_test_sign_in(inputs)
	if (locale === "ko") return ko_meeting_test_sign_in(inputs)
	if (locale === "de") return de_meeting_test_sign_in(inputs)
	if (locale === "ru") return ru_meeting_test_sign_in(inputs)
	if (locale === "tr") return tr_meeting_test_sign_in(inputs)
	if (locale === "it") return it_meeting_test_sign_in(inputs)
	if (locale === "pl") return pl_meeting_test_sign_in(inputs)
	if (locale === "uk") return uk_meeting_test_sign_in(inputs)
	if (locale === "hi") return hi_meeting_test_sign_in(inputs)
	if (locale === "ar") return ar_meeting_test_sign_in(inputs)
	if (locale === "ms") return ms_meeting_test_sign_in(inputs)
	if (locale === "bn") return bn_meeting_test_sign_in(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_sign_in(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_sign_in(inputs)
	if (locale === "ur") return ur_meeting_test_sign_in(inputs)
	if (locale === "fa") return fa_meeting_test_sign_in(inputs)
	if (locale === "sw") return sw_meeting_test_sign_in(inputs)
	if (locale === "nl") return nl_meeting_test_sign_in(inputs)
	return en_meeting_test_sign_in(inputs)
});